import { observer } from 'mobx-react';
import React from 'react';
import { Button, Modal } from 'react-bootstrap';

export interface INotificationModal {
  visible: boolean;
  title: string;
  description: string;
  onClose: () => void;
}

export const NotificationModal = observer(
  ({ visible, title, description, onClose }: INotificationModal) => {
    return (
      <Modal
        centered
        className="confirm-dialog"
        show={visible}
        onHide={onClose}
      >
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="pt-3">{description}</div>
        </Modal.Body>
        <Modal.Footer className="container-fluid">
          <Button variant="primary" className="confirm" onClick={onClose}>
            Ok
          </Button>
        </Modal.Footer>
      </Modal>
    );
  },
);
